<template>
  <div :slot="cellTemplate"
       :slot-scope="data"
       class="data-icone-grid"
  >
    <div class="input-group-append" >
      <div class="top-icon top-settings os-dropdown-trigger os-dropdown-position-left icone-add-debit ">
        <i class="fal fa-ellipsis-v-alt"/>
        <div :class="positionTop"
             class="os-dropdown">
          <ul>

            <li v-for="(button,index) in buttonGrid"
                :class="button.icone"
                :key="index"
                :hidden="button.hidden"
                :dataId="button.id"
                @click.prevent="gridButton(index,data)"
            >
              <span :title="button.title">{{ button.text }}</span>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
	name: 't-button-grid',
	props: {
		cellTemplate: {
			type: String,
			default: 'cellTemplate'
		},
		rowIndex: {
			type: Number,
			default: 0
		},
		data: {
			type: Object,
			default: null
		},

		buttonGrid: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			action: '',
			positionTop: false
		}
	},
	mounted () {
		this.getPostionGrid()
	},
	methods: {
		getPostionGrid () {
		},
		gridButton (index, data) {
			this.action = this.buttonGrid[index].eventClick
			this.$emit('gridButton', this.action, this.data)
		},
		calculateHeightData () {
			var heightDataGrid = this.$('.dx-datagrid-content').height()
			console.log(heightDataGrid)
		}
	}
}
</script>

<style scoped>
td .os-dropdown-trigger.os-dropdown-position-left.over .os-dropdown {
    -webkit-transform: translate3d(calc(-100% - 0px), 3px, 0);
    transform: translate3d(calc(-100% - 0px), 3px, 0);
    bottom: auto;
    position: absolute;
    top: auto;
    right: auto;
    left: auto;
    color: #000;
    background: #fff !important;
    padding: 3px 0 3px 0;
    border: 1px solid rgba(0,0,0,.2);
    -webkit-box-shadow: 0 2px 4px rgba(0,0,0,.2);
    -moz-box-shadow: 0 2px 4px rgba(0,0,0,.2);
    box-shadow: 0 2px 4px rgba(0,0,0,.1);
    min-width: 6vw;
}
td .os-dropdown-trigger.os-dropdown-position-left.over .os-dropdown li {
    padding: 5px 14px;
    border-bottom: 1px solid #fff;
    display:block;
    font-weight: 200;
}
.data-icone-grid{
    text-align: right;
    width: 0%!important;
}
td .modal-Add-icone.modal-Add-icone {
    padding-left: 12px;
    padding-top: 8px;
    right: 0;
    left: auto;
    position: relative;
    height: 30px;
    width: 30px;
    margin-bottom:2px;
    z-index: 1;
}
.defTab td .modal-Add-icone.modal-Add-icone {
    margin-top: 3px;
}
td .input-group-append {
    text-align: right;
    display: block;
}
.icone-add-debit{
 background: transparent !important;
 border: none !important;
}
.head-detail-customers .os-dropdown-trigger.os-dropdown-position-left .os-dropdown li {
    width: 100%;
    padding: 5px 14px;
    border-bottom: 1px solid #fff;
    display: block;
    font-weight: 200;
}
.head-detail-customers .os-dropdown-trigger.os-dropdown-position-left .os-dropdown li span {
    padding-left: 6px;
    font-family: "Helvetica Neue",Arial, sans-serif;
    padding: 3px 13px 3px 20px;
    color: #666;
    font-size: 12px !important;
}
.head-detail-customers .os-dropdown-trigger.os-dropdown-position-left .os-dropdown{
    transition:none;
    box-shadow: 0 2px 4px rgba(0,0,0,.1);
}
.head-detail-customers .os-dropdown-trigger.os-dropdown-position-left .os-dropdown li:hover {
    background: #f6f6f6;
}

</style>



// WEBPACK FOOTER //
// src/components/common/buttonGrid/index.vue